import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { CardMenu } from '@/components/ui/card';
    import { columns } from '@/tables/columns/companies';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import { useUrlSearch } from '@/composables/useUrlSearch';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateCompany from '@/components/companies/CreateCompany.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem, NavItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Companies',
  setup(__props) {

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'companies.header',
            href: route('v2.companies.index'),
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'companies.header',
            href: route('v2.companies.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
        {
            title: 'company-affiliation.navbar_header',
            href: route('v2.company-groups.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
    ];

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.COMPANIES],
        queryFn: getCompanies,
    });

    const { extractAndCleanSearch } = useUrlSearch();
    const initialSearch = extractAndCleanSearch();

    async function getCompanies() {
        const { data } = await axios.get(route('v2.companies.table'), {
            params: {
                search: initialSearch || undefined,
            },
        });
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _ctx.$t('profile.profile_settings')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        (_unref(hasPermission)(_unref(Permission).COMPANIES_VIEW))
          ? (_openBlock(), _createBlock(PageCard, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(DataTable, {
                  "table-key": _unref(QueryKey).COMPANIES,
                  columns: _unref(columns),
                  data: _unref(data),
                  loading: _unref(isPending),
                  "auto-url-search": true
                }, {
                  title: _withCtx(() => [
                    _createVNode(_unref(CardMenu), { items: navItems })
                  ]),
                  actions: _withCtx(() => [
                    _createVNode(DataTableToolbarActions, { name: "companies" }, {
                      default: _withCtx(() => [
                        (_unref(hasPermission)(_unref(Permission).COMPANIES_CREATE))
                          ? (_openBlock(), _createBlock(CreateCompany, { key: 0 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["table-key", "columns", "data", "loading"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})